
import { defineComponent, onMounted, computed, ref } from 'vue'
import { Search, Delete, Tickets, Stopwatch } from '@element-plus/icons-vue'
import { useStore } from '@/store/index'
import { axios } from '@/plugins/axios'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiClose, mdiMinusCircleOutline } from '@mdi/js'
import { toArray } from '@/utils/array'
import { useRouter } from 'vue-router'
import { addSearchQuery } from '@/types/forms/search-word'

export default defineComponent({
  components: { Tickets, Stopwatch, BaseSvgIcon },
  setup() {
    const store = useStore()
    const router = useRouter()
    const search_histories = computed(() =>{return store.getters['search/getSearchHistories']})
    const search_word = ref<string>('')

    const onSearchHistory = (async(search_word_history:string) => {
      store.dispatch('layout/pcSearchingOff')
      if (store.state.layout.searchHistory.open){
        store.dispatch('layout/switchsearchHistoryOpen')
      }
      store.commit('search/setSearchWord', search_word_history)
      store.dispatch('search/postSearch', search_word_history)
        .then(() => {
          store.dispatch('search/fetchSearchHistories')
        })
      await router.push({ path: '/video', query: addSearchQuery(search_word_history) })
    })

    const deleteSearchHistory = (async(search_history_id:number, index:number) => {
      await axios
        .post('/search/history-delete', search_history_id)
        .then(res => {
          store.dispatch('search/fetchSearchHistories')
        })
        .catch((err) =>{
          console.log(err)
        })
    })

    onMounted(() => {
      store.dispatch('search/fetchSearchHistories')
      store.commit('search/setSearchWord')
      search_word.value = store.getters['search/getSearchWord']
    })

    return {
      Search,
      Delete,
      Tickets,
      Stopwatch,
      store,
      search_histories,
      onSearchHistory,
      deleteSearchHistory,
      search_word,
      mdiClose,
      toArray,
      mdiMinusCircleOutline
    }
  },
})
